export default "__VITE_ASSET__IZ5oX6Ve__"